export default "__VITE_ASSET__BvwFpx1L__"